import Modal from '../Modal.component';
import ImageIcon from '@material-ui/icons/Image';
import IconButton from '@material-ui/core/IconButton';
import { ModalImgInterface } from './interfaces/ModalImg';
import { BiX } from 'react-icons/bi';
import { ButtonClose } from '../ModalStyle';

export default function FormComponent({ open, onClick, img, icon = false }: ModalImgInterface) {

  if ((!img || !open) && !icon) {
    return <></>
  }

  return (
    <Modal open={open} handleClick={onClick} margin="0px" icon={icon ? <ImageIcon /> : ''} >
      <ButtonClose>
        <IconButton color="secondary" aria-label="upload picture" component="span" onClick={onClick} >
          <BiX color="#FFFFFF" style={{ background: 'rgba(0,0,0, 0.5)', borderRadius: '50px', padding: '2px' }} />
        </IconButton>
      </ButtonClose>
      <img src={img} alt="link" width='100%' height='auto' style={{ maxWidth: '100%', borderRadius: 4, marginBottom: -7 }} />
    </Modal>
  )
}
